import React from "react";
import PropTypes from "prop-types";

import classNames from "classnames";

const SectionHeader = props => {
    const { introText, titleText, subText, textAlignment, className } = props;

    const classes = classNames("section-heading", className, {
        "section-heading--center-text": textAlignment === "center",
        "section-heading--right-text": textAlignment === "right"
    });

    return (
        <div className={classes}>
            <h4 className="section-heading__intro-text">{introText}</h4>
            <h1 className="section-heading__title-text">{titleText}</h1>
            {subText && <p className="section-heading__sub-text">{subText}</p>}
        </div>
    );
};

SectionHeader.propTypes = {
    className: PropTypes.string,
    introText: PropTypes.string,
    titleText: PropTypes.string.isRequired,
    subText: PropTypes.string,
    textAlignment: PropTypes.oneOf(["center", "right"])
};

export default SectionHeader;



// WEBPACK FOOTER //
// ./src/components/landingPage/SectionHeader.jsx